<div class="chart_container">
  <div [id]="idChart" class="chart" [ngClass]="isEmpty ? 'hide-tooltip' : ''"></div>
</div>